// pages/AppLoaderPage.jsx
import React from 'react';

const AppLoaderPage = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status" />
        <h5 className="text-muted">Preparing your OpenFi workspace...</h5>
      </div>
    </div>
  );
};

export default AppLoaderPage;
